export type WebhookId = string

export interface WebhookInterface {
  id: WebhookId
  name: string
  url: string
  subscriptions: WebhookSubscriptionInterface[]
  active: boolean
}

export interface WebhookSubscriptionInterface {
  id: string
  event: WebhookSubscriptionEventEnum
  disabledAt?: string
  disabledReason?: string
}

export enum WebhookSubscriptionEventEnum {
  ContactCreated = 'CONTACT_CREATED',
  ContactTagAdded = 'CONTACT_TAG_ADDED',
  ContactTagRemoved = 'CONTACT_TAG_REMOVED',
  ContactOptIn = 'CONTACT_OPT_IN',
  SaleNew = 'SALE_NEW',
  SaleCanceled = 'SALE_CANCELED',
}

export type WebhookCreateInterface = Omit<WebhookInterface, 'id' | 'subscriptions'> & {
  secret?: string
  subscriptions: WebhookSubscriptionEventEnum[]
}

export type WebhookUpdateInterface = Partial<Omit<WebhookCreateInterface, 'url'>>

export type WebhookParamsInterface = Omit<WebhookCreateInterface, 'subscriptions'>

export type WebhookErrorsInterface = Omit<WebhookCreateInterface, 'subscriptions' | 'active'> & {
  subscriptions: string
  active: string
}

export interface WebhookErrorViolationInterface {
  code: string
  message: string
  propertyPath: keyof WebhookErrorsInterface
}

export interface WebhookErrorInterface {
  detail: string
  status: number
  title: string
  type: string
  violations: WebhookErrorViolationInterface[]
}

export type WebhookApiInterface = WebhookApiInterface[]
